import { render } from "./NewsAndEvents.vue?vue&type=template&id=9cca8cbe&scoped=true"
import script from "./NewsAndEvents.vue?vue&type=script&lang=js"
export * from "./NewsAndEvents.vue?vue&type=script&lang=js"

import "./NewsAndEvents.vue?vue&type=style&index=0&id=9cca8cbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cca8cbe"]])

export default __exports__